export const PlayIcon = ({ className, onClick }) => (
  <svg
    width="106"
    height="106"
    viewBox="0 0 106 106"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}>
    <g id="Play" clip-path="url(#clip0_2236_25344)">
      <g id="Page-1">
        <g id="Play_2">
          <g id="Vector">
            <path
              d="M53 81.9844C36.9924 81.9844 24.0156 69.0076 24.0156 53C24.0156 36.9924 36.9924 24.0156 53 24.0156C69.0076 24.0156 81.9844 36.9924 81.9844 53C81.9844 69.0076 69.0076 81.9844 53 81.9844ZM53 86.125C71.2944 86.125 86.125 71.2944 86.125 53C86.125 34.7056 71.2944 19.875 53 19.875C34.7056 19.875 19.875 34.7056 19.875 53C19.875 71.2944 34.7056 86.125 53 86.125Z"
              fill="white"
            />
            <path
              d="M45.8417 40.8076C46.5313 40.4527 47.3613 40.513 47.9924 40.9638L62.4846 51.3153C63.0287 51.7039 63.3516 52.3314 63.3516 53C63.3516 53.6686 63.0287 54.2961 62.4846 54.6847L47.9924 65.0363C47.3613 65.487 46.5313 65.5473 45.8417 65.1924C45.1522 64.8376 44.7188 64.1271 44.7188 63.3516V42.6484C44.7188 41.8729 45.1522 41.1625 45.8417 40.8076Z"
              fill="white"
            />
            <path
              d="M53 81.9844C36.9924 81.9844 24.0156 69.0076 24.0156 53C24.0156 36.9924 36.9924 24.0156 53 24.0156C69.0076 24.0156 81.9844 36.9924 81.9844 53C81.9844 69.0076 69.0076 81.9844 53 81.9844ZM53 86.125C71.2944 86.125 86.125 71.2944 86.125 53C86.125 34.7056 71.2944 19.875 53 19.875C34.7056 19.875 19.875 34.7056 19.875 53C19.875 71.2944 34.7056 86.125 53 86.125Z"
              stroke="white"
              stroke-width="0.5"
              stroke-linejoin="round"
            />
            <path
              d="M45.8417 40.8076C46.5313 40.4527 47.3613 40.513 47.9924 40.9638L62.4846 51.3153C63.0287 51.7039 63.3516 52.3314 63.3516 53C63.3516 53.6686 63.0287 54.2961 62.4846 54.6847L47.9924 65.0363C47.3613 65.487 46.5313 65.5473 45.8417 65.1924C45.1522 64.8376 44.7188 64.1271 44.7188 63.3516V42.6484C44.7188 41.8729 45.1522 41.1625 45.8417 40.8076Z"
              stroke="white"
              stroke-width="0.5"
              stroke-linejoin="round"
            />
          </g>
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2236_25344">
        <rect width="106" height="106" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
